import clsx from 'clsx';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import type { SignupSlot } from '@flock-types/signupSheets.types';

interface Props {
  slot: SignupSlot;
  userId?: string;
  disabled: boolean;
  onVote: () => void;
}

/** Survey option: whole row votes (backend swaps any previous vote). */
export default function SurveyOptionRow({ slot, userId, disabled, onVote }: Props) {
  const entries = slot.entries || [];
  const voteCount = entries.length;
  const userVoted = entries.some((e) => e.user_id === userId);

  return (
    <button
      onClick={onVote}
      disabled={disabled}
      className={clsx(
        'flex w-full items-center justify-between gap-3 rounded-xl border bg-white p-4 text-left transition disabled:opacity-60',
        userVoted
          ? 'border-2 border-flock-navy-600'
          : 'border-flock-gray-200 hover:border-flock-navy-400'
      )}
    >
      <span className="flex min-w-0 flex-1 items-center gap-2">
        {userVoted ? (
          <CheckCircleIcon className="h-5 w-5 shrink-0 text-flock-navy-600" />
        ) : (
          <span className="h-5 w-5 shrink-0 rounded-full border-2 border-flock-navy-300" />
        )}
        <span
          className={clsx(
            'truncate font-medium',
            userVoted ? 'text-flock-navy-800' : 'text-flock-navy-600'
          )}
        >
          {slot.label || 'Option'}
        </span>
      </span>
      <span className="shrink-0 rounded-full bg-flock-gray-200 px-3 py-1 text-sm font-semibold text-flock-navy-700">
        {voteCount}
      </span>
    </button>
  );
}
